import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<path fill=\"url(#payment_svg__a)\" d=\"M0 8a8 8 0 0 1 8-8h32a8 8 0 0 1 8 8v32a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"></path><path fill=\"currentColor\" d=\"M30.5 15c1.1 0 2 .9 2 2v1.5H24a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h8.5V31c0 1.1-.9 2-2 2h-14a2 2 0 0 1-2-2V17a2 2 0 0 1 2-2zm3 13h-9c-.55 0-1-.45-1-1v-6c0-.55.45-1 1-1h9zm-6-5.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5S29 24.83 29 24s-.67-1.5-1.5-1.5\"></path><defs><linearGradient id=\"payment_svg__a\" x1=\"2.571\" x2=\"48\" y1=\"2.571\" y2=\"48\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"#58FF90\" stop-opacity=\".64\"></stop><stop offset=\"1\" stop-color=\"#7DFF78\" stop-opacity=\".08\"></stop></linearGradient></defs>", 3)
  ]))]))
}
export default { render: render }